/** @format */

import { defaultActions } from '../../core/actionsDefault';

export const paymentDeadlineCodeConstants = {
    LIST: 'payment_deadline_code_list',
    SELECT_CHANGE: 'payment_deadline_code_select',
};

export class paymentDeadlineCodeActions extends defaultActions {}
